export default __webpack_public_path__ + "static/media/deactivated-bg.76ff97af.svg";